import { useState, useEffect } from 'react'
import { X, Download } from 'lucide-react'

export default function InstallPrompt() {
  const [showPrompt, setShowPrompt] = useState(false)

  useEffect(() => {
    // Only show on mobile
    if (window.innerWidth > 768) {
      setShowPrompt(false)
      return
    }

    // Check if already installed
    if (window.navigator.standalone === true) {
      setShowPrompt(false)
      return
    }

    // Check if user previously dismissed
    const dismissed = localStorage.getItem('install-prompt-dismissed')
    if (dismissed) {
      setShowPrompt(false)
      return
    }

    // Show after 3 seconds
    const timer = setTimeout(() => {
      setShowPrompt(true)
    }, 3000)

    return () => clearTimeout(timer)
  }, [])

  const handleInstall = () => {
    window.installApp()
    setShowPrompt(false)
    localStorage.setItem('install-prompt-dismissed', 'true')
  }

  const handleDismiss = () => {
    setShowPrompt(false)
    localStorage.setItem('install-prompt-dismissed', 'true')
  }

  if (!showPrompt) return null

  return (
    <div className="fixed bottom-4 left-4 right-4 bg-gradient-to-r from-blue-600 to-cyan-500 rounded-lg shadow-2xl z-50 md:hidden">
      <div className="p-4">
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-center gap-3 flex-1">
            <Download className="w-6 h-6 text-white flex-shrink-0" />
            <div>
              <h3 className="font-bold text-white">Install Cybertection</h3>
              <p className="text-sm text-blue-100 mt-1">Get quick access on your home screen</p>
            </div>
          </div>
          <button
            onClick={handleDismiss}
            className="text-white hover:text-blue-100 flex-shrink-0 ml-2"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex gap-2">
          <button
            onClick={handleInstall}
            className="flex-1 bg-white text-blue-600 font-semibold py-2 px-4 rounded-lg hover:bg-blue-50 transition-colors"
          >
            Install Now
          </button>
          <button
            onClick={handleDismiss}
            className="flex-1 bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg hover:bg-blue-800 transition-colors"
          >
            Later
          </button>
        </div>
      </div>
    </div>
  )
}
